import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import { hw } from "features/homework/homeworkUi";

interface ParentInputsProps {
    studentInputs: {
        parent_name: string;
        parent_tel: string;
    };
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ParentInputs = ({ studentInputs, onChange }: ParentInputsProps) => {
    return (
        <Container>
            <Title>학부모 정보</Title>
            <Inputs>
                <InputWithLabel required={true} label="학부모 성명" name="parent_name" value={studentInputs.parent_name} onChange={onChange} />
                <InputWithLabel required={true} label="학부모 전화번호" name="parent_tel" value={studentInputs.parent_tel} onChange={onChange} />
            </Inputs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`;

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

export default ParentInputs;
